import { lazy } from 'react';

const ManageAws = lazy(() => import('./aws/page.js').then((module) => ({ default: module.ManageAws })));
const ManageImage = lazy(() => import('./image/page.js').then((module) => ({ default: module.ManageImage })));
const ManageVideo = lazy(() => import('./video/page.js').then((module) => ({ default: module.ManageVideo })));

export { ManageAws, ManageImage, ManageVideo };
